import { firstItem } from "lib/utils";

export const createFeaturedPubRequestBody = ({ filters, dates, size }) => {
  try {
    const request = {
      query: {
        bool: {
          must: [...filterTerms(filters), ...dateFilters(dates)],
        },
      },
      sort: {
        publicationDate: {
          order: "desc",
        },
      },
      size,
      _source: [
        "analysts",
        "internal",
        "pageCount",
        "regions",
        "id",
        "title",
        "publicationDate",
        "assetClasses",
        "synopsis",
        "gicsIndustryGroups",
        "reportTypes",
        "reportTitles",
        "txCategories",
        "txSubCategories",
        "periodicals",
        "resources",
        "customData.featured",
        "customData.coverImage",
        "instrumentation.wordCount",
        "language",
      ],
      from: 0,
    };
    return request;
  } catch (err) {
    console.error("Unable to create featured search request: ", err);
    return {};
  }
};
const filterTerms = (filters = {}) =>
  Object.entries(filters).map(([key, arr]) => ({
    bool: {
      should: toArray(arr).map((value) => ({ term: { [key]: value } })),
    },
  }));

const dateFilters = ({ fromDate, toDate }) => [
  ...(fromDate ? [{ range: { publicationDate: { gte: firstItem(fromDate) } } }] : []),
  ...(toDate ? [{ range: { publicationDate: { lte: firstItem(toDate) } } }] : []),
];

const toArray = (item) => (Array.isArray(item) ? item : [item]);
